/**
 * Detects if point is inside a rectangle
 * @method pointTest
 * @memberOf physics
 * @param  {Integer} x          The hit's x
 * @param  {Integer} y          The hit's y
 * @param  {Object} boundingBox The min/max x and min/max y properties of a {@link Sprite}
 * @return {Boolean}
 */
const pointRectCollide = (x, y, boundingBox)=> {
    return x >= boundingBox.minX && x <= boundingBox.maxX &&
        y >= boundingBox.minY && y <= boundingBox.maxY;
};

/**
 * Detects whether two rectangles are overlapping
 * @method rectTest
 * @memberOf physics
 * @param  {Sprite} rect1 [description]
 * @param  {Sprite} rect2 [description]
 * @return {Boolean}      
 */
const rectRectCollide = (rect1, rect2)=> {
    let rect1BB = rect1.getBoundingBox();
    let rect2BB = rect2.getBoundingBox();

    if (rect1BB.minX < rect2BB.maxX && rect1BB.maxX > rect2BB.minX &&
        rect1BB.minY < rect2BB.maxY && rect1BB.maxY > rect2BB.minY) {
        return true;
    } else {
        return false;
    }
}

const rectGameDeflect = (rect, currentMoveX, currentMoveY, game)=> {
    let moveX = currentMoveX,
        moveY = currentMoveY;

    if (rect.x < 0 && currentMoveX === -1) {
        moveX = 1;
    }
    if (rect.x + rect.width > game.width && currentMoveX === 1) {
        moveX = -1; 
    }
    if (rect.y < 0 && currentMoveY === -1) {
        moveY = 1;
    }
    if (rect.y + rect.width > game.height && currentMoveY === 1) {
        moveY = -1;
    }

    return { moveX, moveY };
}

export {
    pointRectCollide,
    rectRectCollide
};



/** WEBPACK FOOTER **
 ** ./src/physics/collision.js
 **/